import { render, staticRenderFns } from "./PricingOption.template.vue?vue&type=template&id=2c03b070&scoped=true&"
var script = {}
import style0 from "./PricingOption.template.vue?vue&type=style&index=0&id=2c03b070&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c03b070",
  null
  
)

export default component.exports